import { createSlice } from '@reduxjs/toolkit'
import {
  listPageContentAction,
  detailPageContentAction,
  createPageContentAction,
  updatePageContentAction,
  deletePageContentAction,
  listOrderContentAction,
  sortOrderContentAction,
} from './pageContent.action'

const initialState: PageContent.PageContentState = {
  isLoading: false,
  error: null,
  contents: {
    limit: 0,
    page: 0,
    records: [],
    total: 0,
    totalPage: 0,
  },
  content: null,
  orders: {
    limit: 0,
    page: 0,
    records: [],
    total: 0,
    totalPage: 0,
  },
}

const { actions, reducer } = createSlice({
  name: 'PageContent',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listPageContentAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(listPageContentAction.fulfilled, (state, action) => {
        state.isLoading = false
        state.contents = action.payload
      })
      .addCase(listPageContentAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(detailPageContentAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(detailPageContentAction.fulfilled, (state, action) => {
        state.content = action.payload
        state.isLoading = false;
      })
      .addCase(detailPageContentAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })

      .addCase(createPageContentAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(createPageContentAction.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(createPageContentAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(updatePageContentAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(updatePageContentAction.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updatePageContentAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(deletePageContentAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(deletePageContentAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deletePageContentAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })

      .addCase(listOrderContentAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(listOrderContentAction.fulfilled, (state, action) => {
        state.orders = action.payload
        state.isLoading = false;
      })
      .addCase(listOrderContentAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })

      .addCase(sortOrderContentAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(sortOrderContentAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(sortOrderContentAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
  },
})

export { reducer }
export default actions
